import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ContactHero from './components/ContactHero';
import ContactMethods from './components/ContactMethods';
import MeetingInformation from './components/MeetingInformation';
import ContactForm from './components/ContactForm';
import SocialMediaIntegration from './components/SocialMediaIntegration';
import Footer from '../../components/ui/Footer';

const ContactConnectionCenter = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Contact - Connection Center | Leo Club of Colombo Circle</title>
        <meta 
          name="description" 
          content="Connect with Leo Club of Colombo Circle through multiple channels. Find meeting information, contact details, and join our community of young leaders making a difference in Colombo." 
        />
        <meta name="keywords" content="Leo Club Colombo contact, youth leadership contact, community service Colombo, meeting information, join Leo Club" />
        <meta property="og:title" content="Contact - Connection Center | Leo Club of Colombo Circle" />
        <meta property="og:description" content="Your gateway to joining our community of young leaders. Multiple contact channels, meeting information, and easy ways to get involved." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="/contact-connection-center" />
        <link rel="canonical" href="/contact-connection-center" />
      </Helmet>

      <Header />
      
      <main className="pt-16">
        <ContactHero />
        <ContactMethods />
        <MeetingInformation />
        <ContactForm />
        <SocialMediaIntegration />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ContactConnectionCenter;